import type { AppStore } from "@src/stores/AppStore";
import type { BaseStore } from "@src/stores/BaseStore";
import type { FinancialSettingsState } from "@src/stores/forms/SettingsModalState/FinancialSettingsState";

export class FinancialSettingsStore implements BaseStore {
  constructor(
    public appStore: AppStore,
    public form: FinancialSettingsState,
  ) {}
}
